import restApi from "../../http";
import session from "../session";

class ShopifyApi {
  baseUrl = "/shopify";

  get authHeader() {
    return { Authorization: "Bearer " + session.getAccessToken() };
  }

  getState() {
    return restApi({
      method: "GET",
      url: `${this.baseUrl}/state`,
      // eslint-disable-next-line quotes
      headers: this.authHeader,
    });
  }

  installApp() {
    return restApi({
      method: "GET",
      url: `${this.baseUrl}/install`,
    });
  }

  getToken(data) {
    return restApi({
      method: "POST",
      url: `${this.baseUrl}/get-token`,
      headers: this.authHeader,
      data,
    });
  }

  startImport(shopName) {
    return restApi({
      method: "POST",
      url: `${this.baseUrl}/start-import`,
      headers: this.authHeader,
      data: {
        shopName,
      },
    });
  }
}

export const shopifyApi = new ShopifyApi();
